import { mapBackendTenantToAngular, TenantConfig, TenantDto } from '../tenant.model';
import { TenantRepository } from './tenant.repository';
import { catchError, map, Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../../../environments/environment';

export type TenantLookupOutcome =
  | 'success'
  | 'latency'
  | 'network-error'
  | 'not-found'
  | 'unauthorized'
  | 'forbidden'
  | 'server-failure';


export class TenantRepositoryHttp extends TenantRepository {
  private http = inject(HttpClient)
  private apiUrl = `${environment.apiBaseUrl}/tenants`;
  /**
   * Fetch tenant configuration by client UUID.
   * This is the correct method to call once authentication (P1.1) provides a clientId.
   * Maps to: GET /api/profile
   *
   * @apiNote — HTTP implementation must construct `branding.logoUrl` as:
   *   `GET /api/logo/main`
   *   Never inline binary logo data in the profile JSON response.
   *   Mock implementations may continue using local asset paths (`/assets/images/*.svg`).
   */
  getTenantByClientId(clientId: string): Observable<TenantConfig> {

    return this.http.get<TenantDto>(`${this.apiUrl}/${clientId}`).pipe(
      map(tenant => mapBackendTenantToAngular(tenant)),
      catchError(e => { return of(null, e)})
    );
  }

  getTenantByEmailDomain(domain: string): Observable<TenantConfig> {
    throw new Error("This method is deprecated");
  }

  /**
     * Get all tenant IDs the user can access with a given permission.
     * Semantics are fail-closed:
     * - [] => no access
     * - [tenantId, ...] => restricted access to listed tenants
     */
  loadAccessibleTenants(): Observable<TenantDto[]> {
    return this.http.get<TenantDto[]>(this.apiUrl);
  }
}
